import React from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from "styled-components";

const StyleDescription = styled.div`
  color: var(--grey-grey-9-text-secondary-01, #45505A);
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`

export const TextEditor = ({...props}) => {
    const modules = {
      toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline','strike'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['clean']
      ],
    }
  
    const formats = [
      'header',
      'bold', 'italic', 'underline', 'strike',
      'list', 'bullet', 'indent'
    ]
    
    return(
        <StyleDescription>
            <div className="text-editor">
            <ReactQuill 
                theme="snow"
                modules={modules}
                formats={formats}
                placeholder={props.placeholder || ""}
                 {...props}
            />
            </div>
        </StyleDescription>
    )
  }